import React from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { apiGetCustom } from '../request/api';
import PomeloSwiper from '../components/pomelo-swiper'
import HomePart1 from '../components/home/homePart1'
import HomePart2 from '../components/home/homePart2'
import HomePart3 from '../components/home/homePart3'
import HomePart4 from '../components/home/homePart4'
import HomePart5 from '../components/home/homePart5'
import Bottom from '../components/bottom'
import '../assets/css/home.css'
import { CustomDataProvider } from './context/indexCustomDataContext';

const Home: React.FC = () => {
    return (
        <CustomDataProvider>
            <div className='Home'>
                <PomeloSwiper />
                <div className='home-content'>
                    {/* <HomePart1 /> */}
                    <HomePart2 />
                    <HomePart3 />
                    <HomePart5 />
                    <HomePart4 />
                    <Bottom />
                </div>
            </div>
         </CustomDataProvider>
    );
};

export default Home;
